import { mainBackendApi } from '@/services'
import authSlice from '@/store/auth/authSlice'
import {
	AnyAction,
	ThunkAction,
	ThunkDispatch,
	combineReducers,
	configureStore
} from '@reduxjs/toolkit'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'

const rootReducer = combineReducers({
	[mainBackendApi.reducerPath]: mainBackendApi.reducer,
	auth: authSlice.reducer,
})

export const store = configureStore({
	reducer: rootReducer,
	middleware: getDefaultMiddleware =>
		getDefaultMiddleware().concat([
			mainBackendApi.middleware,
		])
})

export type AppState = ReturnType<typeof store.getState>
export type AppThunk<T = void> = ThunkAction<T, AppState, unknown, AnyAction>
export type AppDispatch = ThunkDispatch<AppState, unknown, AnyAction>

export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector
